import { useEffect, useState } from "react";
import Input from "../../../../../Core/Fields/Floating/Input";
import Button from "../../../../../Core/Button/Button";
import SelectSearchApi from "../../../../../Core/Fields/Floating/SelectSearchApi";
import { formatIndianPriceWithComa } from "../../../../../utils/formatIndianPrice2";

const EditItemModal = ({
    show,
    onClose,
    itemDataReal,
}) => {
    const [itemData, setItemData] = useState({});
    useEffect(() => {
        setItemData(itemDataReal || {});
    }, [itemDataReal]);

    if (!show || !itemData || Object.keys(itemData).length === 0) return null;

    return (
        <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header py-2">
                        <h5 className="modal-title" style={{fontSize:'17.5px'}}>Edit Item Details</h5>
                        <button type="button" style={{fontSize:'14px'}} className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body ">
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="item_code"
                                    label="Design Code"
                                    readOnly
                                    value={itemData?.row?.item?.item_code}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="item_name"
                                    label="Item Name"
                                    readOnly
                                    value={itemData?.row?.item?.item_name}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="custom_diamond_weight"
                                    label="Diamond Weight"
                                    readOnly
                                    value={itemData?.row?.item?.custom_diamond_weight}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="custom_stone_weight"
                                    label=" Stone Weight"
                                    readOnly
                                    value={itemData?.row?.item?.custom_stone_weight}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="custom_pure_gold"
                                    label="Pure Gold"
                                    readOnly
                                    value={itemData?.row?.item?.custom_pure_gold}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="custom_purity"
                                    label="Purity"
                                    readOnly
                                    value={itemData?.row?.item?.custom_purity}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="item_group"
                                    label="Category"
                                    readOnly
                                    value={itemData?.row?.item?.item_group}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="custom_category"
                                    label="Sub Category"
                                    readOnly
                                    value={itemData?.row?.item?.custom_category}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="quantity"
                                    label="Quantity"
                                    readOnly
                                    value={itemData?.row?.quantity}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="uom"
                                    label="UOM"
                                    readOnly
                                    value={itemData?.row?.res2?.uoms?.[0]?.uom}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="tag_price"
                                    label="Tag Price"
                                    readOnly
                                    value={formatIndianPriceWithComa(itemData?.row?.item?.custom_tag_price || 0)}
                                    style={{ height: "30px" }}
                                />
                            </div>
                             <div className="col-6">
                               <Input
                                    id="buying_price"
                                    label="Rate"
                                    value={itemData?.row?.rate ? parseInt(itemData?.row?.rate) : null}
                                    style={{ height: "30px" }}
                                     onChange={(e) => {
                                            const val = parseFloat(e.target.value) || 0;
                                            const tagPrice = parseFloat(itemData?.row?.item?.custom_tag_price) || 0;

                                            // Calculate discount
                                            const discountAmount = tagPrice - val;
                                            const discountPercentage = tagPrice ? ((discountAmount / tagPrice) * 100).toFixed(2) : 0;

                                            // Update rows
                                            const updatedRows = itemData.rows.map((r, idx) =>
                                            idx === itemData.index2
                                                ? {
                                                    ...r,
                                                    rate: val,
                                                    margin_discount_percentage: discountPercentage,
                                                    margin_discount_amount: discountAmount,
                                                    margin_rate_or_amount:'',
                                                }
                                                : r
                                            );

                                            itemData.setRows(updatedRows);

                                            // Update local modal state
                                            setItemData({
                                            ...itemData,
                                            row: {
                                                ...itemData.row,
                                                rate: val,
                                                margin_discount_percentage: discountPercentage,
                                                margin_discount_amount: discountAmount,
                                                margin_rate_or_amount:'',
                                            },
                                            });
                                        }}
                                />

                            </div>
                            </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                    <SelectSearchApi
                                        list={[{"value":"Percentage"},{"value":"Amount"}]}
                                        label="Margin Type"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        value={itemData?.row?.margin_type}
                                        onChange={(e) => {
                                            if(parseInt(itemData?.row?.margin_rate_or_amount) > 0){
                                                   const updatedRows = itemData.rows.map((r, idx) => idx === itemData.index2 ? { ...r, margin_type: e,margin_rate_or_amount:''} : r);
                                                   itemData.setRows(updatedRows);
                                                   setItemData({...itemData,row: { ...itemData.row, margin_type: e,margin_rate_or_amount:'',margin_discount_percentage:'',margin_discount_amount:'',rate:parseFloat(itemData?.row?.item?.custom_tag_price)}});
                                            }else{
                                                const updatedRows = itemData.rows.map((r, idx) => idx === itemData.index2 ? { ...r, margin_type: e,margin_rate_or_amount:''} : r);
                                                   itemData.setRows(updatedRows);
                                                   setItemData({...itemData,row: { ...itemData.row, margin_type: e,margin_rate_or_amount:''}});
                                            }     
                                        }}
                                    />
                            </div>

                            <div className="col-6">
                               <Input
                                    id="margin_rate_or_amount"
                                    label="Margin Rate or Amount"
                                    value={itemData?.row?.margin_rate_or_amount || ""}
                                    style={{ height: "30px" }}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const tagPrice = parseFloat(itemData?.row?.item?.custom_tag_price) || 0;
                                        const marginType = itemData?.row?.margin_type || "";
                                        let discountPercentage = 0;
                                        let discountAmount = 0;

                                        if (marginType === "Percentage") {
                                        discountPercentage = val;
                                        discountAmount = (tagPrice * val) / 100;
                                        } else if (marginType === "Amount") {
                                        discountAmount = val;
                                        discountPercentage = (val / tagPrice) * 100;
                                        }

                                        const updatedRows = itemData.rows.map((r, idx) =>
                                        idx === itemData.index2
                                            ? {
                                                ...r,
                                                margin_rate_or_amount: val,
                                                margin_discount_percentage: discountPercentage,
                                                margin_discount_amount: discountAmount,
                                                rate: tagPrice - discountAmount,
                                            }
                                            : r
                                        );

                                        itemData.setRows(updatedRows);

                                        setItemData({
                                        ...itemData,
                                        row: {
                                            ...itemData.row,
                                            margin_rate_or_amount: val,
                                            margin_discount_percentage: discountPercentage,
                                            margin_discount_amount: discountAmount,
                                            rate: tagPrice - discountAmount,
                                        },
                                        });
                                    }}
                                />

                            </div>
                        </div>



                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="Discountpercentage"
                                    label="Discount (%) on Price List Rate with Margin"
                                    readOnly
                                    value={itemData?.row?.margin_discount_percentage}
                                    style={{ height: "30px" }}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    id="DiscountAmount"
                                    label="Discount Amount"
                                    readOnly
                                    value={formatIndianPriceWithComa(itemData?.row?.margin_discount_amount)}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>    
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input
                                    id="selling_price"
                                    label="Amount"
                                    readOnly
                                    value={formatIndianPriceWithComa(itemData?.row?.rate * parseInt(itemData?.row?.quantity))}
                                    style={{ height: "30px" }}
                                />
                            </div>
                        </div>

                        </div>

                    <div className="modal-footer">
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName=""
                            iconSize={12}
                            onClick={onClose}                                                >
                           Close
                        </Button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditItemModal;